/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-range',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    input[type='range'] {
      @apply h-4 cursor-pointer appearance-none rounded-lg border bg-white;
    }

    input[type='range']::-webkit-slider-runnable-track {
      @apply h-4 rounded-lg border bg-white;
    }

    input[type='range']::-webkit-slider-thumb {
      @apply bg-primary-500 size-4 cursor-grab appearance-none rounded-full border-2;
    }

    input[type='range']::-webkit-slider-thumb:active {
      @apply cursor-grabbing;
    }

    input[type='range']:disabled {
      @apply cursor-not-allowed opacity-50;
    }

    input[type='range']:disabled::-webkit-slider-thumb {
      @apply border-primary-200 bg-primary-300 cursor-not-allowed;
    }

    input[type='range']::-moz-range-thumb {
      @apply border-primary-300 bg-primary-700 size-8 cursor-grab appearance-none rounded-full border-2;
    }

    input[type='range']::-moz-range-thumb:active {
      @apply cursor-grabbing;
    }

    input[type='range']:disabled::-moz-range-thumb {
      @apply cursor-not-allowed;
    }
  `,
  template: `
    <input
      type="range"
      [min]="min()"
      [max]="max()"
      [value]="value()"
      (input)="onInput($event)"
      [disabled]="isDisabled"
      class="w-full" />
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeComponent),
      multi: true,
    },
  ],
})
export class RangeComponent implements ControlValueAccessor {
  value = model(100);
  min = input(0);
  max = input(100);
  isDisabled = false;

  private cdr = inject(ChangeDetectorRef);

  onChange = (value: number) => {
    // Ignoré.
  };
  onTouched = () => {
    // Ignoré.
  };

  onInput(event: Event): void {
    const inputValue = +(event.target as HTMLInputElement).value;
    this.value.set(inputValue);
    this.onChange(inputValue); // Notify the form about the change
  }

  writeValue(value: number): void {
    this.value.set(value);
    this.onChange(value); // Notify the form about the change
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;

    this.cdr.markForCheck();
  }
}
